(function () {
  "use strict";

  var BUY_SPIRITS_PATHS = ["/pages/buy-spirits", "/pages/buy-spirits-preview-tnd0608"];
  var BIND_TIMEOUT_MS = 25000;
  var TOGGLE_IFRAME_SELECTOR = ".shopify-buy-frame--toggle iframe";
  var COUNT_SELECTOR = ".shopify-buy__cart-toggle__count";
  var DRAWER_TAG = "tnd-unified-drawer";
  var bodyObserver = null;
  var frameObserver = null;
  var countObserver = null;
  var giveUpTimer = 0;
  var bound = false;
  var lastCount = null;

  if (BUY_SPIRITS_PATHS.indexOf(window.location.pathname) === -1) return;

  function disconnectObserver(observer) {
    if (!observer) return;
    observer.disconnect();
  }

  function parseCount(node) {
    var value = node ? Number(String(node.textContent || "").trim()) : NaN;
    return Number.isFinite(value) ? value : null;
  }

  function getDrawer() {
    return document.querySelector(DRAWER_TAG);
  }

  function isDrawerOpen() {
    var drawer = getDrawer();
    return !!(drawer && !drawer.hidden && drawer.getAttribute("data-open") === "true");
  }

  function openDrawerWhenReady() {
    var startedAt = Date.now();
    var readyTimer;

    if (isDrawerOpen()) return;

    function open() {
      if (isDrawerOpen()) {
        clearInterval(readyTimer);
        return;
      }

      if (window.TND && window.TND.drawer && typeof window.TND.drawer.open === "function") {
        clearInterval(readyTimer);
        requestAnimationFrame(function () {
          window.TND.drawer.open();
        });
        return;
      }

      if (Date.now() - startedAt > BIND_TIMEOUT_MS) {
        clearInterval(readyTimer);
      }
    }

    open();
    readyTimer = setInterval(open, 100);
  }

  function handleCountChange(node) {
    var nextCount = parseCount(node);

    if (nextCount === null) return;
    if (lastCount === null) {
      lastCount = nextCount;
      return;
    }

    if (nextCount > lastCount) {
      lastCount = nextCount;
      openDrawerWhenReady();
      return;
    }

    lastCount = nextCount;
  }

  function bindCountNode(node) {
    bound = true;
    clearTimeout(giveUpTimer);
    disconnectObserver(bodyObserver);
    disconnectObserver(frameObserver);

    handleCountChange(node);
    countObserver = new MutationObserver(function () {
      handleCountChange(node);
    });
    countObserver.observe(node, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }

  function getFrameDocument(iframe) {
    try {
      return iframe && (iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document));
    } catch (error) {
      return null;
    }
  }

  function observeFrameDocument(frameDocument) {
    if (!frameDocument || frameObserver) return;

    if (frameDocument.body) {
      frameObserver = new MutationObserver(tryBind);
      frameObserver.observe(frameDocument.body, {
        childList: true,
        subtree: true
      });
    }
  }

  function tryBind() {
    var iframe;
    var frameDocument;
    var countNode;

    if (bound) return true;

    iframe = document.querySelector(TOGGLE_IFRAME_SELECTOR);
    if (!iframe) return false;

    frameDocument = getFrameDocument(iframe);
    if (!frameDocument) return false;

    countNode = frameDocument.querySelector(COUNT_SELECTOR);
    if (countNode) {
      bindCountNode(countNode);
      return true;
    }

    observeFrameDocument(frameDocument);
    iframe.addEventListener("load", tryBind, { once: true });
    return false;
  }

  function startBinding() {
    if (tryBind()) return;

    bodyObserver = new MutationObserver(tryBind);
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    giveUpTimer = setTimeout(function () {
      disconnectObserver(bodyObserver);
      disconnectObserver(frameObserver);
    }, BIND_TIMEOUT_MS);
  }

  if (document.body) {
    startBinding();
  } else {
    document.addEventListener("DOMContentLoaded", startBinding, { once: true });
  }
})();
